<div>
<div class="mb-1">
  <p>Attachment (optional)</p>
  <input type="file" ng2FileSelect (onFileSelected)="disableSubmit()" [uploader]="uploader" />
</div>

<div *ngIf="uploader" class="mb-1">
  <div ng2FileDrop [ngClass]="{'dz-file-over': hasBaseDropZoneOver}" (fileOver)="fileOverBase($event)" (onFileDrop)="disableSubmit()"
    [uploader]="uploader" class="fileupload-drop-zone mb-24">
    Drop file here
  </div>
</div>
<table *ngIf="uploader.queue.length>0" class="default-table mat-box-shadow mb-24" style="width: 100%">
  <thead>
    <tr>
      <th width="25%">Name</th>
      <th>Size</th>
      <th>Actions</th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody *ngIf="uploader.queue.length; else tableNoData">
    <tr *ngFor="let item of uploader.queue">
      <td>{{ item?.file?.name }}</td>
      <td nowrap>{{ item?.file?.size/1024/1024 | number:'.2' }} MB</td>
      <td nowrap>Progress: {{item?.progress}}%</td>
      <td nowrap>
        <button mat-raised-button color="warn" class="mx-4" (click)="uploader.removeFromQueue(item);removeAttachment()">Remove</button>
      </td>
    </tr>
  </tbody>
  <ng-template #tableNoData>
    <p [ngStyle]="{padding: '0 1.2rem'}">No attachments</p>
  </ng-template>
</table>

</div>